import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VMOnlineApiService } from 'src/app/vmonline-api.service';
import { DownloadService } from './components/shared/services/download.service';

// Old VM Online (v10) emails linked to a download page, e.g.
// vm/Download?category=SuppWorkflowReport&id={guid}&filename={name}
// The old page is gone, but the file still lives in S3 and the KAI "email-reports" endpoint can
// stream it back by its id + filename. So we fetch it (authenticated, via Cobra) and then drop the
// user on the reports list. If the file no longer exists, the download service shows an error.
@Component({
	selector: 'app-legacy-report-download',
	template: '',
})
export class LegacyReportDownloadComponent implements OnInit {
	private route = inject(ActivatedRoute);
	private router = inject(Router);
	private vmOnlineApi = inject(VMOnlineApiService);
	private downloadService = inject(DownloadService);

	ngOnInit(): void {
		const queryParams = this.route.snapshot.queryParamMap;
		const id = queryParams.get('id');
		const filename = queryParams.get('filename');

		if (id && filename) {
			const url = `${this.vmOnlineApi.propertyValuationsUrl('email-reports')}/${id}`;
			this.downloadService.downloadFile(url, { filename });
		}

		void this.router.navigate(['/reports/job-runs']);
	}
}
